import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KVariance_INVARIANT_instance;
var KVariance_IN_instance;
var KVariance_OUT_instance;
var KVariance_entriesInitialized;
function KVariance_initEntries() {
  if (KVariance_entriesInitialized)
    return Unit_instance;
  KVariance_entriesInitialized = true;
  KVariance_INVARIANT_instance = KVariance().et('INVARIANT', 0);
  KVariance_IN_instance = KVariance().et('IN', 1);
  KVariance_OUT_instance = KVariance().et('OUT', 2);
}
var KVarianceClass;
function KVariance() {
  if (KVarianceClass === VOID) {
    class $ extends Enum() {
      static et(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'KVariance');
    KVarianceClass = $;
  }
  return KVarianceClass;
}
function KVariance_INVARIANT_getInstance() {
  KVariance_initEntries();
  return KVariance_INVARIANT_instance;
}
//region block: exports
export {
  KVariance_INVARIANT_getInstance as KVariance_INVARIANT_getInstancesuq4f4bi5uun,
};
//endregion

//# sourceMappingURL=KVariance.mjs.map
